import React from "react";
import styled from "styled-components";
import { BRAND_NAME } from "../../lib/constants";

const Wrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: ${(p) => p.theme.colors.text};
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.02em;
  svg {
    flex: 0 0 auto;
  }
`;

/** Знак CS Hub (из favicon.svg) и текстовое имя бренда. Текст скрывается в узком rail. */
export default function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <Wrap>
      <svg width="32" height="32" viewBox="0 0 64 64" aria-hidden="true">
        <rect width="64" height="64" rx="14" fill="#1b2430" />
        <path d="M14 32c0-8 5-13 12-13h6v7h-5c-3 0-5 2-5 6s2 6 5 6h5v7h-6c-7 0-12-5-12-13Z" fill="#f2f5f8" />
        <path d="M36 43v-7h8c1.5 0 2.500-.8 2.500-2s-1-2-2.500-2h-4c-3.500 0-6-2.400-6-6s2.500-6 6-6h10v7h-8c-1 0-1.500.5-1.500 1.500S41 29 42 29h4c3.500 0 6 2.500 6 6.500S49.500 43 46 43Z" fill="#ff9b57" />
      </svg>
      <span className={compact ? "brand-text sr-only" : "brand-text"}>{BRAND_NAME}</span>
    </Wrap>
  );
}
